export type InterfaceLanguage = "en" | "ms" | "sabah" | "zh";

const BM_COPY: Record<string, string> = {
  "Kitanego home": "Halaman utama Kitanego",
  "Interactive prototype": "Prototaip interaktif",
  "Design preview": "Pratonton reka bentuk",
  "Choose design style": "Pilih gaya reka bentuk",
  "Style:": "Gaya:",
  "Original": "Asal",
  "Exit": "Keluar",
  "Close": "Tutup",
  "Add your signal": "Tambah isyarat anda",
  "Four small steps. No sensitive financial details.": "Empat langkah ringkas. Tiada butiran kewangan sensitif.",
  "About you": "Tentang anda",
  "Your categories": "Kategori anda",
  "Regular products": "Produk tetap",
  "Buying rhythm": "Corak pembelian",
  "Your contact details stay private.": "Butiran hubungan anda kekal peribadi.",
  "Suppliers see anonymous totals only.": "Pembekal hanya melihat jumlah tanpa nama.",
  "Before you begin": "Sebelum anda bermula",
  "You appear to be outside Sabah.": "Anda kelihatan berada di luar Sabah.",
  "Location isn’t available here.": "Lokasi tidak tersedia di sini.",
  "Location access is required.": "Akses lokasi diperlukan.",
  "We couldn’t confirm your location.": "Kami tidak dapat mengesahkan lokasi anda.",
  "Allow location to continue.": "Benarkan lokasi untuk meneruskan.",
  "This places your registration on Kitanego’s Sabah map. Suppliers only see anonymous totals.": "Ini meletakkan pendaftaran anda pada peta Sabah Kitanego. Pembekal hanya melihat jumlah tanpa nama.",
  "Try location again": "Cuba lokasi sekali lagi",
  "Waiting for permission": "Menunggu kebenaran",
  "Choose Allow in your browser to open registration.": "Pilih Benarkan dalam pelayar anda untuk membuka pendaftaran.",
  "Used only for the admin map preview in this prototype.": "Digunakan hanya untuk pratonton peta pentadbir dalam prototaip ini.",
  "Step 1 of 4": "Langkah 1 daripada 4",
  "Create a Kitanego Account.": "Cipta Akaun Kitanego.",
  "Use your Google account.": "Gunakan akaun Google anda.",
  "Help": "Bantuan",
  "Terms": "Terma",
  "Next": "Seterusnya",
  "Monthly Wishlist": "Senarai Hasrat Bulanan",
  "When do you plan to buy?": "Bilakah anda merancang untuk membeli?",
  "Choose a wishlist month": "Pilih bulan senarai hasrat",
  "Choose a month": "Pilih bulan",
  "Select one month to continue": "Pilih satu bulan untuk meneruskan",
  "Pick your products": "Pilih produk anda",
  "Choose your shopping list for this month.": "Pilih senarai barangan anda untuk bulan ini.",
  "Choose your brands.": "Pilih jenama anda.",
  "Select brands from the list, search, or add a new brand. This step is optional.": "Pilih jenama daripada senarai, cari atau tambah jenama baharu. Langkah ini adalah pilihan.",
  "Budget spending plan": "Pelan perbelanjaan bajet",
  "How do you plan on buying the items on your wishlist?": "Bagaimanakah anda merancang untuk membeli barangan dalam senarai hasrat anda?",
  "How often do you buy these products?": "Berapa kerap anda membeli produk ini?",
  "Expected monthly spend": "Anggaran perbelanjaan bulanan",
  "Hoping to find a more budget-friendly option": "Berharap untuk mendapatkan pilihan yang lebih menjimatkan",
  "Review": "Semak",
  "Your product categories are created automatically from your selected products.": "Kategori produk anda diwujudkan secara automatik daripada produk yang dipilih.",
  "Expected spend": "Anggaran perbelanjaan",
  "Submitting…": "Sedang menghantar…",
  "your selected month": "bulan pilihan anda",
  "wishlist saved": "senarai hasrat disimpan",
  "Your monthly wishlist could not be saved. Please try again.": "Senarai hasrat bulanan anda tidak dapat disimpan. Sila cuba lagi.",
  "No matching products": "Tiada produk yang sepadan",
  "Try another product name or clear your search.": "Cuba nama produk lain atau kosongkan carian.",
  "Clear search": "Kosongkan carian",
  "Your favourite brand": "Jenama kegemaran anda",
  "Search catalogue brands": "Cari jenama katalog",
  "Selected brands": "Jenama dipilih",
  "Lists of Brands": "Senarai Jenama",
  "Suggested matches": "Padanan dicadangkan",
  "View retail item": "Lihat produk runcit",
  "Brand image not available": "Imej jenama tidak tersedia",
  "Can’t find it? Suggest a new brand for review": "Tidak jumpa? Cadangkan jenama baharu untuk semakan",
  "Finding brand names…": "Mencari nama jenama…",
  "Sending suggestion…": "Menghantar cadangan…",
  "Suggest": "Cadangkan",
  "Web App Admin will review its name and image": "Pentadbir aplikasi web akan menyemak nama dan imejnya",
  "Under review": "Dalam pertimbangan",
  "Brand submitted and added to your list. It is under review.": "Jenama telah dihantar dan ditambah pada senarai anda. Jenama ini dalam pertimbangan.",
  "Brand added to your list. It will be submitted for review when registration is completed.": "Jenama ditambah pada senarai anda. Jenama ini akan dihantar untuk pertimbangan selepas pendaftaran selesai.",
  "Select a listed brand or suggest a new brand for review.": "Pilih jenama tersenarai atau cadangkan jenama baharu untuk pertimbangan.",
  "This brand is already selected.": "Jenama ini telah dipilih.",
  "No listed catalogue brands match your search.": "Tiada jenama katalog yang sepadan dengan carian anda.",
  "All available brands are selected.": "Semua jenama yang tersedia telah dipilih.",
  "Step 2 of 5": "Langkah 2 daripada 5",
  "Choose your district.": "Pilih daerah anda.",
  "Step 3 of 5": "Langkah 3 daripada 5",
  "Choose the products you buy regularly.": "Pilih produk yang anda beli secara tetap.",
  "Step 4 of 5": "Langkah 4 daripada 5",
  "Select a brand from the available list. You can suggest a new brand after registration.": "Pilih jenama daripada senarai yang tersedia. Anda boleh mencadangkan jenama baharu selepas pendaftaran.",
  "Step 5 of 5": "Langkah 5 daripada 5",
  "Saving…": "Sedang menyimpan…",
  "Full name": "Nama penuh",
  "e.g. Aina Rahman": "cth. Aina Rahman",
  "Email address": "Alamat e-mel",
  "District in Sabah": "Daerah di Sabah",
  "Select your district": "Pilih daerah anda",
  "Choose the district that covers your town. We never ask for your exact address.": "Pilih daerah yang merangkumi bandar anda. Kami tidak pernah meminta alamat tepat anda.",
  "Registration location": "Lokasi pendaftaran",
  "Optional": "Pilihan",
  "Captured for this browser’s admin map preview.": "Dirakam untuk pratonton peta pentadbir dalam pelayar ini.",
  "Allow once to place this registration on the admin map preview.": "Benarkan sekali untuk meletakkan pendaftaran ini pada pratonton peta pentadbir.",
  "Latitude": "Latitud",
  "Longitude": "Longitud",
  "Accuracy": "Ketepatan",
  "Stored only in this browser for the prototype, shown in its admin preview, and excluded from supplier reports. You can remove it under Profile & privacy.": "Disimpan hanya dalam pelayar ini untuk prototaip, dipaparkan dalam pratonton pentadbir dan dikecualikan daripada laporan pembekal. Anda boleh membuangnya di bawah Profil & privasi.",
  "Getting location…": "Mendapatkan lokasi…",
  "Update location": "Kemas kini lokasi",
  "Use my current location": "Gunakan lokasi semasa saya",
  "Remove": "Buang",
  "Create free profile": "Cipta profil percuma",
  "Prototype authentication": "Pengesahan prototaip",
  "Check your inbox.": "Semak peti masuk anda.",
  "We sent a secure sign-in link to": "Kami menghantar pautan log masuk selamat kepada",
  "In the finished product, that link signs you in without a password.": "Dalam produk siap, pautan itu akan melog masuk anda tanpa kata laluan.",
  ". In the finished product, that link signs you in without a password.": ". Dalam produk siap, pautan itu akan melog masuk anda tanpa kata laluan.",
  "Simulate opening the link": "Simulasikan membuka pautan",
  "Use a different email": "Gunakan e-mel lain",
  "This step is simulated for the UI prototype.": "Langkah ini disimulasikan untuk prototaip UI.",
  "Step 2 of 4": "Langkah 2 daripada 4",
  "What would you like to save on?": "Apakah yang anda ingin jimatkan?",
  "Choose everything that matters. You can change this later.": "Pilih semua yang penting. Anda boleh mengubahnya kemudian.",
  "Step 3 of 4": "Langkah 3 daripada 4",
  "Make your signal specific.": "Jadikan isyarat anda lebih khusus.",
  "Which of these do you buy regularly?": "Yang manakah anda beli secara tetap?",
  "Search products": "Cari produk",
  "Step 4 of 4": "Langkah 4 daripada 4",
  "How does this fit your routine?": "Bagaimanakah ini sesuai dengan rutin anda?",
  "An estimate is enough. We use ranges, not exact spending.": "Anggaran sudah memadai. Kami menggunakan julat, bukan perbelanjaan tepat.",
  "How often do you usually buy these?": "Berapa kerap anda biasanya membeli barangan ini?",
  "About how much at a time?": "Kira-kira berapa banyak pada satu-satu masa?",
  "If a better price became available…": "Jika harga yang lebih baik tersedia…",
  "This does not place an order.": "Ini tidak membuat pesanan.",
  "Your answers only add to the community’s anonymous demand signal.": "Jawapan anda hanya menambah kepada isyarat permintaan komuniti tanpa nama.",
  "Add my signal": "Tambah isyarat saya",
  "Back": "Kembali",
  "Groceries": "Barangan runcit",
  "Everyday pantry": "Keperluan dapur harian",
  "Home care": "Penjagaan rumah",
  "Cleaning essentials": "Keperluan pembersihan",
  "Personal care": "Penjagaan diri",
  "Daily routines": "Rutin harian",
  "Baby products": "Produk bayi",
  "Family essentials": "Keperluan keluarga",
  "Mobile & data": "Mudah alih & data",
  "Plans and top-ups": "Pelan dan tambah nilai",
  "Fuel & transport": "Bahan api & pengangkutan",
  "Getting around": "Perjalanan harian",
  "Food & dining": "Makanan & sajian",
  "Meals out": "Makan di luar",
  "Clothing": "Pakaian",
  "Wardrobe basics": "Keperluan pakaian",
  "Cooking oil": "Minyak masak",
  "Rice": "Beras",
  "Fresh milk": "Susu segar",
  "Eggs": "Telur",
  "Coffee": "Kopi",
  "Instant noodles": "Mi segera",
  "Laundry detergent": "Detergen pakaian",
  "Dishwashing liquid": "Cecair pencuci pinggan",
  "Tissue": "Tisu",
  "Floor cleaner": "Pencuci lantai",
  "Shampoo": "Syampu",
  "Body wash": "Sabun badan",
  "Toothpaste": "Ubat gigi",
  "Skincare": "Penjagaan kulit",
  "Diapers": "Lampin",
  "Baby formula": "Susu formula bayi",
  "Baby wipes": "Tisu basah bayi",
  "Baby toiletries": "Kelengkapan mandian bayi",
  "Mobile data": "Data mudah alih",
  "Home internet": "Internet rumah",
  "Prepaid top-up": "Tambah nilai prabayar",
  "Fuel": "Bahan api",
  "E-hailing": "E-panggilan",
  "Public transport pass": "Pas pengangkutan awam",
  "Family meals": "Hidangan keluarga",
  "Alcoholic Beverages": "Minuman beralkohol",
  "Bath & Body Wash": "Mandian & sabun badan",
  "Breads & Bakery": "Roti & bakeri",
  "Cereals & Breakfast Foods": "Bijirin & makanan sarapan",
  "Canned & Preserved Foods": "Makanan dalam tin & diawet",
  "Chips, Nuts & Seeds": "Kerepek, kekacang & bijian",
  "Chocolates & Sweets": "Coklat & gula-gula",
  "Home Cleaning Supplies": "Barangan pembersihan rumah",
  "Coffee, Tea & Infusions": "Kopi, teh & minuman herba",
  "Biscuits & Confectionery": "Biskut & konfeksi",
  "Cooking Oils & Fats": "Minyak masak & lemak",
  "Baby Diapers & Care": "Lampin & penjagaan bayi",
  "Beverages & Refreshments": "Minuman & penyegar",
  "Small Home Appliances": "Peralatan rumah kecil",
  "Pantry Staples": "Keperluan asas dapur",
  "Hair Care & Styling": "Penjagaan & penggayaan rambut",
  "Household Essentials": "Keperluan isi rumah",
  "Pest & Insect Control": "Kawalan perosak & serangga",
  "Instant Beverage Mixes": "Campuran minuman segera",
  "Noodles, Pasta & Quick Meals": "Mi, pasta & hidangan segera",
  "Laundry Care": "Penjagaan dobi",
  "Health & Remedies": "Kesihatan & rawatan",
  "Ready-to-Drink Milk": "Susu sedia diminum",
  "Powdered Milk & Formula": "Susu tepung & formula",
  "Oral Care": "Penjagaan mulut",
  "Paper Goods & Tissue": "Produk kertas & tisu",
  "Fragrances & Deodorants": "Wangian & deodoran",
  "Pet Food & Supplies": "Makanan & bekalan haiwan peliharaan",
  "Feminine Hygiene": "Kebersihan wanita",
  "Sauces & Condiments": "Sos & perasa",
  "Seasonings & Flavour Enhancers": "Bahan perasa & penambah rasa",
  "Skin Care & Beauty": "Penjagaan kulit & kecantikan",
  "Savoury Snacks": "Snek berperisa",
  "Breakfast Spreads": "Sapuan sarapan",
  "Latest community demand": "Permintaan komuniti terkini",
  "Regular products summary": "Ringkasan produk tetap",
  "product selections": "pilihan produk",
  "unique products": "produk unik",
  "No regular product selections yet.": "Tiada pilihan produk tetap lagi.",
  "Brands summary": "Ringkasan jenama",
  "brand selections": "pilihan jenama",
  "unique brands": "jenama unik",
  "No brand selections yet.": "Tiada pilihan jenama lagi.",
  "High-demand products": "Produk permintaan tinggi",
  "active members": "ahli aktif",
  "high-demand products": "produk permintaan tinggi",
  "No products are currently selected by two or more active members.": "Tiada produk yang sedang dipilih oleh dua atau lebih ahli aktif.",
  "New brands added": "Jenama baharu ditambah",
  "approved additions": "penambahan diluluskan",
  "new brands": "jenama baharu",
  "No suggested brands have been approved yet.": "Tiada jenama cadangan yang diluluskan lagi.",
  "Close summary": "Tutup ringkasan",
  "Rank": "Kedudukan",
  "Based only on current selections from active member accounts. Archived and deleted users are excluded.": "Berdasarkan pilihan semasa daripada akaun ahli aktif sahaja. Pengguna yang diarkibkan dan dipadam tidak disertakan.",
  "Suggested by members and approved by Kitanego administrators.": "Dicadangkan oleh ahli dan diluluskan oleh pentadbir Kitanego.",
  "Lunch deals": "Tawaran makan tengah hari",
  "Coffee & drinks": "Kopi & minuman",
  "School uniforms": "Pakaian seragam sekolah",
  "Workwear": "Pakaian kerja",
  "Everyday basics": "Pakaian asas harian",
  "Daily": "Harian",
  "Weekly": "Mingguan",
  "Every two weeks": "Setiap dua minggu",
  "Monthly": "Bulanan",
  "Every few months": "Setiap beberapa bulan",
  "Occasionally": "Sekali-sekala",
  "Under RM50": "Bawah RM50",
  "Above RM500": "Melebihi RM500",
  "Definitely interested": "Pasti berminat",
  "Probably interested": "Mungkin berminat",
  "Maybe if price is better": "Mungkin jika harga lebih baik",
  "Not interested": "Tidak berminat",
  "Home": "Utama",
  "Interests": "Minat",
  "Wishlists": "Senarai hasrat",
  "Opportunity": "Peluang",
  "Profile": "Profil",
  "Member navigation": "Navigasi ahli",
  "Verified member": "Ahli disahkan",
  "Registered member": "Ahli berdaftar",
  "Admin preview": "Pratonton pentadbir",
  "Notifications": "Pemberitahuan",
  "VERIFIED": "DISAHKAN",
  "REGISTERED": "BERDAFTAR",
  "Good morning,": "Selamat pagi,",
  "Your signal is live. Here’s how it’s gathering strength.": "Isyarat anda aktif. Lihat bagaimana ia semakin kukuh.",
  "Update interests": "Kemas kini minat",
  "Your demand signal": "Isyarat permintaan anda",
  "Sample data": "Data contoh",
  "products": "produk",
  "high demand products": "produk permintaan tinggi",
  "high demand product": "produk permintaan tinggi",
  "brands selected": "jenama dipilih",
  "new brands added": "jenama baharu ditambah",
  "new brand added": "jenama baharu ditambah",
  "Every choice adds weight.": "Setiap pilihan menambah kekuatan.",
  "Your strongest shared signal is currently": "Isyarat bersama terkuat anda kini ialah",
  "groceries in": "barangan runcit di",
  "See your signal": "Lihat isyarat anda",
  "Account status": "Status akaun",
  "Verified": "Disahkan",
  "Registered": "Berdaftar",
  "Your mobile number is verified for pilot opportunities.": "Nombor mudah alih anda disahkan untuk peluang rintis.",
  "Phone verification comes only when you choose an opportunity.": "Pengesahan telefon hanya berlaku apabila anda memilih peluang.",
  "Community pulse": "Nadi komuniti",
  "What people are signalling": "Perkara yang diisyaratkan oleh komuniti",
  "Illustrative prototype totals": "Jumlah ilustrasi prototaip",
  "interested in groceries": "berminat dengan barangan runcit",
  "strongest category": "kategori terkuat",
  "signals from Kota Kinabalu": "isyarat dari Kota Kinabalu",
  "general area only": "kawasan umum sahaja",
  "interested in rice": "berminat dengan beras",
  "aggregated count": "jumlah agregat",
  "Pilot scenario": "Senario rintis",
  "An opportunity matching your signal": "Peluang yang sepadan dengan isyarat anda",
  "See details": "Lihat butiran",
  "Everyday rice": "Beras harian",
  "Everyday": "Beras",
  "rice": "harian",
  "prototype product": "produk prototaip",
  "Pilot interest test": "Ujian minat rintis",
  "Everyday rice · 10kg": "Beras harian · 10kg",
  "Help show a supplier how much credible demand exists. This is not an order.": "Bantu tunjukkan kepada pembekal jumlah permintaan yang diyakini. Ini bukan pesanan.",
  "Community target": "Sasaran komuniti",
  "68% · sample progress": "68% · kemajuan contoh",
  "What suppliers see": "Perkara yang dilihat pembekal",
  "Your identity never enters the conversation.": "Identiti anda tidak pernah dikongsi dalam perbincangan.",
  "You": "Anda",
  "Anonymous totals": "Jumlah tanpa nama",
  "Supplier discussion": "Perbincangan pembekal",
  "Your signal": "Isyarat anda",
  "My interests": "Minat saya",
  "My Wishlists": "Senarai pilihan saya",
  "Regular products and brands.": "Produk dan jenama pilihan.",
  "brands": "jenama",
  "Your favourite brands": "Jenama kegemaran anda",
  "Your brands": "Jenama anda",
  "My favourite brands": "Jenama kegemaran saya",
  "My brand lists": "Senarai jenama saya",
  "Search or add a brand": "Cari atau tambah jenama",
  "My product category": "Kategori produk saya",
  "Listed based on my wishlists product": "Disenaraikan berdasarkan produk dalam senarai pilihan saya",
  "Interest sections": "Bahagian senarai pilihan",
  "Clear product search": "Kosongkan carian produk",
  "Save and confirm product choices": "Simpan dan sahkan pilihan produk",
  "Open product editor": "Buka penyunting produk",
  "Add existing product": "Tambah produk sedia ada",
  "Suggest a new product": "Cadangkan produk baharu",
  "Clear brand search": "Kosongkan carian jenama",
  "Save and confirm brand choices": "Simpan dan sahkan pilihan jenama",
  "Choose a listed brand": "Pilih jenama yang disenaraikan",
  "Open brand editor": "Buka penyunting jenama",
  "Add listed brand": "Tambah jenama yang disenaraikan",
  "Send to Web App Admin for review": "Hantar kepada Pentadbir Aplikasi Web untuk semakan",
  "Enter at least two letters to search or suggest a brand.": "Masukkan sekurang-kurangnya dua huruf untuk mencari atau mencadangkan jenama.",
  "Select a product to automatically add its category.": "Pilih produk untuk menambah kategorinya secara automatik.",
  "Choose your regular products": "Pilih produk tetap anda",
  "Choose your regular brands": "Pilih jenama tetap anda",
  "Select": "Pilih",
  "Unselect": "Nyahpilih",
  "Add": "Tambah",
  "product": "produk",
  "image": "imej",
  "Enlarge": "Besarkan",
  "No products match your search.": "Tiada produk yang sepadan dengan carian anda.",
  "Select at least one category to see its products.": "Pilih sekurang-kurangnya satu kategori untuk melihat produknya.",
  "No selected products match your search.": "Tiada produk terpilih yang sepadan dengan carian anda.",
  "Individual retail item": "Item runcit individu",
  "Brand image not available yet": "Imej jenama belum tersedia",
  "No linked products yet": "Belum ada produk yang dipautkan",
  "No brands match your search.": "Tiada jenama yang sepadan dengan carian anda.",
  "All available brands are already selected.": "Semua jenama yang tersedia telah dipilih.",
  "No selected brands match your search.": "Tiada jenama terpilih yang sepadan dengan carian anda.",
  "Add a brand with the search or plus button above.": "Tambah jenama menggunakan carian atau butang tambah di atas.",
  "PRODUCT CATEGORY": "KATEGORI PRODUK",
  "How often do I buy this?": "Berapa kerap saya membeli produk ini?",
  "Remove product": "Buang produk",
  "Close product details": "Tutup butiran produk",
  "BRAND DETAILS": "BUTIRAN JENAMA",
  "How often do I buy this brand?": "Berapa kerap saya membeli jenama ini?",
  "Remove brand": "Buang jenama",
  "Close brand details": "Tutup butiran jenama",
  "Close enlarged image": "Tutup imej yang dibesarkan",
  "Your monthly demand.": "Permintaan bulanan anda.",
  "Choose a monthly demand": "Pilih permintaan bulanan",
  "Update": "Kemas kini",
  "Keep your regular buying pattern current.": "Pastikan corak pembelian tetap anda sentiasa terkini.",
  "Autosaved": "Disimpan automatik",
  "categories": "kategori",
  "shaping your signal": "membentuk isyarat anda",
  "selected regularly": "dipilih secara tetap",
  "district": "daerah",
  "used for local totals": "digunakan untuk jumlah setempat",
  "Categories": "Kategori",
  "Products": "Produk",
  "Brands": "Jenama",
  "Select or remove anything that matters to your household.": "Pilih atau buang perkara yang penting kepada isi rumah anda.",
  "Your regular products": "Produk tetap anda",
  "How often do you buy": "Berapa kerap anda membeli",
  "How often do I buy": "Berapa kerap saya membeli",
  "Search or add a product": "Cari atau tambah produk",
  "Product choices from your current categories.": "Pilihan produk daripada kategori semasa anda.",
  "Edit products": "Sunting produk",
  "Back to home": "Kembali ke halaman utama",
  "Prototype product": "Produk prototaip",
  "Pilot opportunity": "Peluang rintis",
  "Illustrative": "Ilustrasi",
  "Help demonstrate credible demand for a household staple. A supplier discussion may follow if enough verified members record interest.": "Bantu menunjukkan permintaan yang diyakini bagi barangan keperluan isi rumah. Perbincangan dengan pembekal mungkin menyusul jika cukup ahli disahkan merekodkan minat.",
  "Interest closes": "Minat ditutup",
  "30 November 2026": "30 November 2026",
  "Area": "Kawasan",
  "Greater Kota Kinabalu": "Kota Kinabalu Raya",
  "Limit": "Had",
  "Up to 3 units": "Sehingga 3 unit",
  "Today": "Hari ini",
  "No payment": "Tiada bayaran",
  "Target 1,500": "Sasaran 1,500",
  "Prototype progress based on illustrative data": "Kemajuan prototaip berdasarkan data ilustrasi",
  "What this means": "Maksudnya",
  "A signal of intent—not a purchase.": "Isyarat niat—bukan pembelian.",
  "You choose a quantity": "Anda memilih kuantiti",
  "It helps measure the number of units members may want.": "Ia membantu mengukur bilangan unit yang mungkin dikehendaki ahli.",
  "Your phone is verified": "Telefon anda disahkan",
  "One mobile number helps protect the credibility of the count.": "Satu nombor mudah alih membantu melindungi kebolehpercayaan kiraan.",
  "No payment or order": "Tiada bayaran atau pesanan",
  "Nothing is charged, reserved, delivered or guaranteed in this prototype.": "Tiada apa-apa yang dicaj, ditempah, dihantar atau dijamin dalam prototaip ini.",
  "Supplier evidence preview": "Pratonton bukti pembekal",
  "Only the combined picture.": "Hanya gambaran gabungan.",
  "Suppliers would see aggregate evidence such as:": "Pembekal akan melihat bukti agregat seperti:",
  "Verified interest": "Minat disahkan",
  "members": "ahli",
  "Potential demand": "Permintaan berpotensi",
  "units": "unit",
  "Top area": "Kawasan utama",
  "Kota Kinabalu · aggregated": "Kota Kinabalu · agregat",
  "Names, emails and phone numbers excluded": "Nama, e-mel dan nombor telefon dikecualikan",
  "Your interest is recorded": "Minat anda telah direkodkan",
  "Add your signal to this pilot": "Tambah isyarat anda kepada rintis ini",
  "Committed to this pilot only": "Komited kepada rintis ini sahaja",
  "View commitment": "Lihat komitmen",
  "You’re verified and ready to record a quantity.": "Anda telah disahkan dan bersedia merekodkan kuantiti.",
  "Verify your phone only when you choose to participate.": "Sahkan telefon anda hanya apabila anda memilih untuk turut serta.",
  "Choose quantity": "Pilih kuantiti",
  "Verify and record interest": "Sahkan dan rekod minat",
  "Your contact details are not shared with suppliers.": "Butiran hubungan anda tidak dikongsi dengan pembekal.",
  "Verification at the moment that matters": "Pengesahan pada saat yang penting",
  "One real member.": "Seorang ahli sebenar.",
  "One stronger signal.": "Satu isyarat lebih kukuh.",
  "We ask for a mobile number only when you choose a pilot opportunity. It helps keep community demand credible.": "Kami meminta nombor mudah alih hanya apabila anda memilih peluang rintis. Ini membantu memastikan permintaan komuniti boleh dipercayai.",
  "Private by default": "Peribadi secara lalai",
  "Your number is never included in supplier reports.": "Nombor anda tidak pernah dimasukkan dalam laporan pembekal.",
  "Short-lived code": "Kod jangka pendek",
  "Production codes will expire and requests will be rate-limited.": "Kod produksi akan tamat tempoh dan permintaan akan dihadkan.",
  "Step 1 of 2": "Langkah 1 daripada 2",
  "Verify only when it matters.": "Sahkan hanya apabila diperlukan.",
  "Enter the mobile number you want linked to this member account.": "Masukkan nombor mudah alih yang ingin dipautkan kepada akaun ahli ini.",
  "Mobile number": "Nombor mudah alih",
  "Send verification code": "Hantar kod pengesahan",
  "Standard SMS charges may apply in the finished product.": "Caj SMS standard mungkin dikenakan dalam produk siap.",
  "Change number": "Tukar nombor",
  "Step 2 of 2": "Langkah 2 daripada 2",
  "Enter the 6-digit code.": "Masukkan kod 6 digit.",
  "Verification code": "Kod pengesahan",
  "Prototype code:": "Kod prototaip:",
  "Verify and continue": "Sahkan dan teruskan",
  "Resend code": "Hantar semula kod",
  "How many would you consider?": "Berapa banyak yang anda pertimbangkan?",
  "Choose a quantity to help make the demand signal more useful.": "Pilih kuantiti untuk menjadikan isyarat permintaan lebih berguna.",
  "10kg · prototype": "10kg · prototaip",
  "Maximum 3 units": "Maksimum 3 unit",
  "Decrease quantity": "Kurangkan kuantiti",
  "Increase quantity": "Tambah kuantiti",
  "Intent only—no payment and no order.": "Niat sahaja—tiada bayaran dan tiada pesanan.",
  "You can withdraw this expression of interest before the pilot closes on 30 November 2026.": "Anda boleh menarik balik pernyataan minat ini sebelum rintis ditutup pada 30 November 2026.",
  "Not now": "Bukan sekarang",
  "COMMITTED · THIS PILOT ONLY": "KOMITED · RINTIS INI SAHAJA",
  "You’re counted—": "Anda dikira—",
  "not charged.": "tidak dicaj.",
  "Count me in for": "Sertakan saya untuk",
  "unit": "unit",
  "Your interest in": "Minat anda terhadap",
  "has been recorded. Your account remains VERIFIED; this commitment belongs only to this pilot.": "telah direkodkan. Akaun anda kekal DISAHKAN; komitmen ini hanya untuk rintis ini.",
  "Quantity": "Kuantiti",
  "Payment": "Bayaran",
  "None": "Tiada",
  "Status": "Status",
  "Expression of intent": "Pernyataan minat",
  "View opportunity": "Lihat peluang",
  "Your account": "Akaun anda",
  "Profile & privacy": "Profil & privasi",
  "Manage your details and understand how your data is used.": "Urus butiran anda dan fahami cara data anda digunakan.",
  "COMMITTED TO 1 PILOT": "KOMITED KEPADA 1 RINTIS",
  "District": "Daerah",
  "Map location": "Lokasi peta",
  "Captured": "Dirakam",
  "District only": "Daerah sahaja",
  "Joined": "Menyertai",
  "Prototype session": "Sesi prototaip",
  "Edit profile": "Sunting profil",
  "Privacy controls": "Kawalan privasi",
  "Preview the anonymous report": "Pratonton laporan tanpa nama",
  "Remove map location": "Buang lokasi peta",
  "Delete the coordinates saved in this browser": "Padam koordinat yang disimpan dalam pelayar ini",
  "Download my data": "Muat turun data saya",
  "Prototype action": "Tindakan prototaip",
  "Privacy notice": "Notis privasi",
  "How information is handled": "Cara maklumat dikendalikan",
  "Prototype tools": "Alat prototaip",
  "Reset all locally saved demo progress and return to the landing page.": "Tetapkan semula semua kemajuan demo yang disimpan secara setempat dan kembali ke halaman utama.",
  "Reset prototype": "Tetapkan semula prototaip",
  "Overview": "Gambaran keseluruhan",
  "Members": "Ahli",
  "Demand": "Permintaan",
  "Opportunities": "Peluang",
  "Reports": "Laporan",
  "Command centre": "Pusat arahan",
  "Admin navigation": "Navigasi pentadbir",
  "Member preview": "Pratonton ahli",
  "Prototype dataset": "Set data prototaip",
  "Reporting period": "Tempoh laporan",
  "Last 7 days": "7 hari terakhir",
  "Last 30 days": "30 hari terakhir",
  "All time": "Sepanjang masa",
  "Admin sections": "Bahagian pentadbir",
  "Demand command centre": "Pusat arahan permintaan",
  "The community, in focus.": "Komuniti dalam fokus.",
  "Understand credible demand without exposing individual members.": "Fahami permintaan yang diyakini tanpa mendedahkan ahli individu.",
  "Export aggregate report": "Eksport laporan agregat",
  "Prototype dataset.": "Set data prototaip.",
  "Totals and clusters are illustrative; a captured session location is labelled separately.": "Jumlah dan kelompok adalah ilustrasi; lokasi sesi yang dirakam dilabel secara berasingan.",
  "Registered members": "Ahli berdaftar",
  "Verified members": "Ahli disahkan",
  "Deal commitments": "Komitmen tawaran",
  "Active products": "Produk aktif",
  "rate": "kadar",
  "of verified": "daripada yang disahkan",
  "of total": "daripada jumlah",
  "8 categories": "8 kategori",
  "Membership funnel": "Corong keahlian",
  "From interest to intent": "Daripada minat kepada niat",
  "Open members": "Buka ahli",
  "View": "Lihat",
  "Profile complete": "Profil lengkap",
  "Committed": "Komited",
  "Highest opportunity": "Peluang tertinggi",
  "Improve profile completion after registration.": "Tingkatkan pelengkapan profil selepas pendaftaran.",
  "Category demand": "Permintaan kategori",
  "Signals by category": "Isyarat mengikut kategori",
  "Explore": "Teroka",
  "Personal": "Peribadi",
  "Telecom": "Telekom",
  "Transport": "Pengangkutan",
  "Baby": "Bayi",
  "Registration geography": "Geografi pendaftaran",
  "Where demand is forming": "Tempat permintaan terbentuk",
  "Browser-local preview": "Pratonton setempat pelayar",
  "Geography": "Geografi",
  "Top demand areas": "Kawasan permintaan tertinggi",
  "Supplier evidence": "Bukti pembekal",
  "Rice · 10kg pilot": "Rintis beras · 10kg",
  "Live test": "Ujian langsung",
  "Interested": "Berminat",
  "Units": "Unit",
  "expressed": "dinyatakan",
  "Aggregate-safe export. No member identifiers or coordinates included.": "Eksport selamat agregat. Tiada pengecam ahli atau koordinat dimasukkan.",
  "Community health": "Kesihatan komuniti",
  "Members, without the guesswork.": "Ahli, tanpa teka-teki.",
  "Export aggregate members": "Eksport agregat ahli",
  "Anonymised prototype view.": "Paparan prototaip tanpa nama.",
  "Names, emails, phone numbers and precise coordinates are not shown here.": "Nama, e-mel, nombor telefon dan koordinat tepat tidak dipaparkan di sini.",
  "New this period": "Baharu tempoh ini",
  "Profiles complete": "Profil lengkap",
  "Search members": "Cari ahli",
  "Search ID, district or category": "Cari ID, daerah atau kategori",
  "Filter by district": "Tapis mengikut daerah",
  "All districts": "Semua daerah",
  "Filter by status": "Tapis mengikut status",
  "All statuses": "Semua status",
  "Member": "Ahli",
  "Strongest signal": "Isyarat terkuat",
  "Current browser": "Pelayar semasa",
  "CURRENT": "SEMASA",
  "This browser": "Pelayar ini",
  "Profile state": "Keadaan profil",
  "Complete": "Lengkap",
  "Needs attention": "Perlu perhatian",
  "Location consent": "Kebenaran lokasi",
  "Location allowed": "Lokasi dibenarkan",
  "Privacy": "Privasi",
  "No direct identifiers shown": "Tiada pengecam langsung dipaparkan",
  "No matching members": "Tiada ahli sepadan",
  "Adjust the search or filters to see more prototype records.": "Laraskan carian atau penapis untuk melihat lebih banyak rekod prototaip.",
  "Clear filters": "Kosongkan penapis",
  "Buying signals": "Isyarat pembelian",
  "See what Sabah wants next.": "Lihat perkara yang Sabah inginkan seterusnya.",
  "Export demand snapshot": "Eksport ringkasan permintaan",
  "Interactive demand view.": "Paparan permintaan interaktif.",
  "Choose a category or district scope to explore the illustrative signals.": "Pilih kategori atau skop daerah untuk meneroka isyarat ilustrasi.",
  "Active signals": "Isyarat aktif",
  "Categories tracked": "Kategori dijejaki",
  "38 active products": "38 produk aktif",
  "Fastest growth": "Pertumbuhan terpantas",
  "Districts represented": "Daerah diwakili",
  "Sabah coverage": "Liputan Sabah",
  "Category ranking": "Kedudukan kategori",
  "Demand by members": "Permintaan mengikut ahli",
  "Demand scope": "Skop permintaan",
  "All Sabah": "Seluruh Sabah",
  "last 7 days": "7 hari terakhir",
  "last 30 days": "30 hari terakhir",
  "all time": "sepanjang masa",
  "in": "dalam",
  "members showing an active buying signal in": "ahli menunjukkan isyarat pembelian aktif di",
  "Inspect": "Periksa",
  "Selected signal": "Isyarat dipilih",
  "momentum this period": "momentum tempoh ini",
  "Product momentum": "Momentum produk",
  "Signals becoming supplier-ready": "Isyarat menuju kesediaan pembekal",
  "Aggregate only": "Agregat sahaja",
  "Product": "Produk",
  "Trend": "Trend",
  "Pilot pipeline": "Saluran rintis",
  "Turn strong signals into pilots.": "Ubah isyarat kukuh menjadi rintis.",
  "Create prototype opportunity": "Cipta peluang prototaip",
  "Prototype pipeline.": "Saluran prototaip.",
  "Statuses show how a signal moves from validation to supplier-ready evidence.": "Status menunjukkan cara isyarat bergerak daripada pengesahan kepada bukti sedia pembekal.",
  "Live pilots": "Rintis aktif",
  "Ready to launch": "Sedia dilancarkan",
  "Strong evidence": "Bukti kukuh",
  "Total commitments": "Jumlah komitmen",
  "Current live pilot": "Rintis aktif semasa",
  "Verified conversion": "Penukaran disahkan",
  "Of verified members": "Daripada ahli disahkan",
  "Filter opportunities": "Tapis peluang",
  "All": "Semua",
  "Live": "Aktif",
  "Supplier-ready": "Sedia pembekal",
  "Validating": "Sedang disahkan",
  "Cooking oil · 5kg": "Minyak masak · 5kg",
  "Rice · 10kg": "Beras · 10kg",
  "Family mobile data": "Data mudah alih keluarga",
  "commitments": "komitmen",
  "of": "daripada",
  "districts": "daerah",
  "Coverage": "Liputan",
  "Timing": "Masa",
  "Ready for review": "Sedia untuk semakan",
  "Signal building": "Isyarat sedang dibina",
  "View details": "Lihat butiran",
  "Selected opportunity": "Peluang dipilih",
  "The signal has reached": "Isyarat telah mencapai",
  "prototype commitments across": "komitmen prototaip merentasi",
  ". The next production step is supplier review with aggregate evidence only.": ". Langkah produksi seterusnya ialah semakan pembekal menggunakan bukti agregat sahaja.",
  "Preview evidence": "Pratonton bukti",
  "Download CSV": "Muat turun CSV",
  "Evidence library": "Pustaka bukti",
  "Evidence ready to share.": "Bukti sedia untuk dikongsi.",
  "Generate aggregate CSV": "Jana CSV agregat",
  "Privacy-safe by design.": "Selamat privasi mengikut reka bentuk.",
  "Every report uses grouped counts and excludes direct identifiers and registration coordinates.": "Setiap laporan menggunakan kiraan berkumpulan dan mengecualikan pengecam langsung serta koordinat pendaftaran.",
  "Weekly demand pulse": "Nadi permintaan mingguan",
  "Category movement, leading products and district growth.": "Pergerakan kategori, produk utama dan pertumbuhan daerah.",
  "Membership & verification": "Keahlian & pengesahan",
  "Registration quality and verified conversion by district.": "Kualiti pendaftaran dan penukaran disahkan mengikut daerah.",
  "Supplier evidence pack": "Pek bukti pembekal",
  "Aggregate intent and commitment evidence for the rice pilot.": "Bukti niat dan komitmen agregat untuk rintis beras.",
  "District coverage snapshot": "Ringkasan liputan daerah",
  "Grouped participation counts across Sabah districts.": "Kiraan penyertaan berkumpulan di seluruh daerah Sabah.",
  "Updated": "Dikemas kini",
  "Yesterday": "Semalam",
  "Preview": "Pratonton",
  "Download": "Muat turun",
  "Report preview": "Pratonton laporan",
  "What every export excludes": "Perkara yang dikecualikan daripada setiap eksport",
  "Names, emails, phone numbers and exact registration coordinates. The current-session admin map remains browser-local in this prototype.": "Nama, e-mel, nombor telefon dan koordinat pendaftaran tepat. Peta pentadbir sesi semasa kekal setempat dalam pelayar bagi prototaip ini.",
  "Sabah registration location map": "Peta lokasi pendaftaran Sabah",
  "Illustrative registration clusters across Sabah": "Kelompok pendaftaran ilustrasi di seluruh Sabah",
  ". No device location has been captured in this browser": ". Tiada lokasi peranti dirakam dalam pelayar ini",
  "Illustrative clusters": "Kelompok ilustrasi",
  "This prototype session": "Sesi prototaip ini",
  "Location available": "Lokasi tersedia",
  "Latest registration located.": "Pendaftaran terkini telah dikenal pasti.",
  "No device location yet.": "Belum ada lokasi peranti.",
  "This current browser session is plotted separately from the illustrative clusters.": "Sesi pelayar semasa ini diplot secara berasingan daripada kelompok ilustrasi.",
  "Members can still register using their selected district when location permission is declined or unavailable.": "Ahli masih boleh mendaftar menggunakan daerah pilihan apabila kebenaran lokasi ditolak atau tidak tersedia.",
  "Selected district": "Daerah dipilih",
  "Device accuracy": "Ketepatan peranti",
  "The map will update after a member chooses “Use my current location.”": "Peta akan dikemas kini selepas ahli memilih “Gunakan lokasi semasa saya.”",
  "Browser-local preview.": "Pratonton setempat pelayar.",
  "Names and emails stay off the map. Supplier reports exclude coordinates.": "Nama dan e-mel tidak dipaparkan pada peta. Laporan pembekal mengecualikan koordinat.",
  "Prototype note: the current-session point is stored only in this browser until the live data service is connected.": "Nota prototaip: titik sesi semasa disimpan hanya dalam pelayar ini sehingga perkhidmatan data langsung disambungkan.",
  "Registration location captured": "Lokasi pendaftaran dirakam",
  "Your buying signal is live": "Isyarat pembelian anda kini aktif",
  "Magic link simulated": "Pautan ajaib disimulasikan",
  "Interests saved on this device": "Minat disimpan pada peranti ini",
  "Mobile number verified": "Nombor mudah alih disahkan",
  "Prototype code sent": "Kod prototaip dihantar",
  "No new admin alerts": "Tiada amaran pentadbir baharu",
  "Demo profile loaded": "Profil demo dimuatkan",
  "Prototype reset": "Prototaip ditetapkan semula",
  "Your monthly Demand": "Permintaan bulanan anda",
  "Latest updates": "Kemas kini terkini",
  "Last login:": "Log masuk terakhir:",
  "Welcome to Kitanego!": "Selamat datang ke Kitanego!",
  "We are absolutely thrilled to have you with us. 🙌 Thank you for joining this movement right from the start. By registering, you aren't just joining a platform—you are helping launch something massive. Together, we are building a powerful collective-buying network that will fundamentally change lives and bring much-needed relief to communities that need it most. Your presence makes our collective voice stronger. Get ready, because we are about to make a huge impact together!": "Kami sangat gembira anda bersama kami. 🙌 Terima kasih kerana menyertai gerakan ini sejak awal. Dengan mendaftar, anda bukan sekadar menyertai sebuah platform—anda membantu melancarkan sesuatu yang besar. Bersama-sama, kita sedang membina rangkaian pembelian kolektif yang kukuh untuk membawa perubahan bermakna dan membantu komuniti yang paling memerlukannya. Kehadiran anda menguatkan suara kolektif kita. Bersedialah, kerana kita akan mencipta impak yang besar bersama-sama!",
  "We are absolutely thrilled to have you with us. 🙌 Thank you for joining this effort right from the start. By registering, you aren't just joining a platform—you are helping launch something massive. Together, we are building a powerful collective-buying network that will fundamentally change lives and bring much-needed relief to communities that need it most. Your presence makes our collective voice stronger. Get ready, because we are about to make a huge impact together!": "Kami sangat gembira anda bersama kami. 🙌\n\nTerima kasih kerana menyertai usaha ini sejak awal. Dengan mendaftar, anda bukan sekadar menyertai sebuah platform—anda membantu melancarkan sesuatu yang besar.\n\nBersama-sama, kita sedang membina rangkaian pembelian kolektif yang kukuh yang akan mengubah kehidupan secara asas dan membawa kelegaan yang amat diperlukan kepada komuniti yang paling memerlukannya.\n\nKehadiran anda menguatkan suara kolektif kita. Bersedialah, kerana kita akan mencipta impak yang besar bersama-sama!",
  "Loading latest news…": "Memuatkan berita terkini…",
  "Latest news is temporarily unavailable": "Berita terkini tidak tersedia buat sementara waktu",
  "No latest news yet": "Belum ada berita terkini",
  "Please check again shortly.": "Sila semak semula sebentar lagi.",
  "Updates posted by Kitanego will appear here.": "Kemas kini daripada Kitanego akan dipaparkan di sini.",
  "Welcome to Kitanego — your choices help build stronger collective demand.": "Selamat datang ke Kitanego — pilihan anda membantu membina permintaan kolektif yang lebih kukuh.",
};

const SABAH_COPY: Record<string, string> = {
  "Choose language": "Pilih bahasa bah",
  "Pilih bahasa": "Pilih bahasa bah",
  "Bersama membina peluang Sabah": "Sama-sama kita bina peluang Sabah bah",
  "Kuasa membeli, bersama.": "Kuasa membeli sama-sama bah.",
  "We are absolutely thrilled to have you with us. 🙌 Thank you for joining this effort right from the start. By registering, you aren't just joining a platform—you are helping launch something massive. Together, we are building a powerful collective-buying network that will fundamentally change lives and bring much-needed relief to communities that need it most. Your presence makes our collective voice stronger. Get ready, because we are about to make a huge impact together!": "Kami memang gembira betul kamu bersama kami. 🙌\n\nTerima kasih sebab ikut usaha ini dari awal lagi. Bila kamu mendaftar, kamu bukan sekadar masuk satu platform—kamu sedang bantu kasi mula sesuatu yang besar.\n\nSama-sama, kita sedang bina rangkaian pembelian kolektif yang kuat untuk ubah kehidupan dan bawa kelegaan yang sangat diperlukan kepada komuniti yang paling memerlukannya.\n\nKehadiran kamu kasi kuat suara kita semua. Bersedia bah, sebab kita akan buat impak besar sama-sama!",
  "Daftar sekarang": "Daftar sekarang bah",
  "Kitanego anda": "Kitanego kamu",
  "Butiran Pengguna": "Butiran Kamu",
  "Urus maklumat ahli dan butiran akaun anda.": "Urus maklumat ahli sama butiran akaun kamu.",
  "Home": "Laman utama",
  "Utama": "Laman utama",
  "Wishlists": "Senarai pilihan",
  "Senarai hasrat": "Senarai pilihan",
  "Latest updates": "Info terbaru",
  "Your monthly Demand": "Permintaan bulanan kamu",
  "Dashboard": "Dashboard",
  "Profile settings": "Tetapan profil",
  "Log out": "Log keluar",
  "Language": "Bahasa",
  "No new alerts": "Nda ada notis baru",
  "No new admin alerts": "Nda ada notis pentadbir baru",
  "No matching members": "Nda ada ahli yang sepadan",
  "No device location yet.": "Lokasi peranti belum ada lagi.",
  "No direct identifiers shown": "Nda paparkan pengenalan terus",
  "Your buying signal is live": "Isyarat belian kamu sudah aktif bah",
  "See what Sabah wants next.": "Tengok apa yang urang Sabah mau seterusnya.",
  "Tell us what matters": "Bagitau kami apa yang penting",
  "We combine the signal": "Kitaorang gabungkan isyarat",
  "You decide whether to take part.": "Kamu pilih sendiri mau ikut ka nda.",
  "Open member dashboard": "Buka dashboard ahli",
  "Free to join": "Percuma mau ikut",
  "No card details": "Nda perlu butiran kad",
  "Location only with permission": "Lokasi kalau kamu kasi izin saja",
  "Back": "Balik",
  "Close": "Tutup",
  "Next": "Seterusnya",
  "Save": "Simpan",
  "Cancel": "Batal",
  "Search products": "Cari produk",
  "Search members": "Cari ahli",
  "Use my current location": "Pakai lokasi saya sekarang",
  "Try location again": "Cuba lokasi lagi",
  "Allow location to continue.": "Kasi izin lokasi untuk teruskan.",
  "Location access is required.": "Akses lokasi memang perlu bah.",
  "We couldn’t confirm your location.": "Kitaorang nda dapat sahkan lokasi kamu.",
  "You appear to be outside Sabah.": "Macam kamu berada di luar Sabah.",
  "Check your inbox.": "Cuba tengok peti masuk kamu.",
  "Use a different email": "Pakai e-mel lain",
  "Choose everything that matters. You can change this later.": "Pilih semua yang penting. Nanti boleh tukar lagi.",
  "This does not place an order.": "Ini bukan terus bikin pesanan.",
  "Clear filters": "Buang semua tapisan",
  "View details": "Tengok butiran",
  "Download": "Muat turun",
};

const textOriginals = new WeakMap<Text, string>();
const attributeOriginals = new WeakMap<Element, Map<string, string>>();
const translatedAttributes = ["aria-label", "placeholder", "title", "data-label"] as const;

const normalizedCopyCache = new WeakMap<object, Map<string, string>>();

function normalizeTranslationText(value: string): string {
  return value
    .normalize("NFKC")
    .replace(/[\u200B-\u200D\uFE0F\uFEFF]/g, "")
    .replace(/[\u2018\u2019\u02BC]/g, "'")
    .replace(/[\u2013\u2212]/g, "—")
    .replace(/\s+/g, " ")
    .trim();
}

function findTranslatedCopy(copy: Record<string, string>, value: string): string | undefined {
  const exact = copy[value];
  if (exact) return exact;

  let normalizedCopy = normalizedCopyCache.get(copy);
  if (!normalizedCopy) {
    normalizedCopy = new Map(
      Object.entries(copy).map(([source, translation]) => [normalizeTranslationText(source), translation]),
    );
    normalizedCopyCache.set(copy, normalizedCopy);
  }
  return normalizedCopy.get(normalizeTranslationText(value));
}

function translateDynamic(value: string): string {
  const direct = findTranslatedCopy(BM_COPY, value);
  if (direct) return direct;

  const patterns: Array<[RegExp, (...parts: string[]) => string]> = [
    [/^Good morning, (.+)\.$/, (name) => `Selamat pagi, ${name}.`],
    [/^Good afternoon, (.+)\.$/, (name) => `Selamat tengah hari, ${name}.`],
    [/^Good evening, (.+)\.$/, (name) => `Selamat petang, ${name}.`],
    [/^Good night, (.+)\.$/, (name) => `Selamat malam, ${name}.`],
    [/^Last login: (.+)$/, (when) => `Log masuk terakhir: ${when}`],
    [/^groceries in (.+)$/, (district) => `barangan runcit di ${district}`],
    [/^Continue · (\d+) selected$/, (count) => `Teruskan · ${count} dipilih`],
    [/^Continue · (\d+) products$/, (count) => `Teruskan · ${count} produk`],
    [/^(\d[\d,]*) of (\d[\d,]*) units$/, (count, target) => `${count} daripada ${target} unit`],
    [/^(\d[\d,]*) units expressed$/, (count) => `${count} unit dinyatakan`],
    [/^Sent to (.+)\. It expires after 10 minutes in the finished product\.$/, (phone) => `Dihantar kepada ${phone}. Kod tamat selepas 10 minit dalam produk siap.`],
    [/^Count me in for (\d+) unit$/, (count) => `Sertakan saya untuk ${count} unit`],
    [/^Count me in for (\d+) units$/, (count) => `Sertakan saya untuk ${count} unit`],
    [/^Your interest in (.+) has been recorded\. Your account remains VERIFIED; this commitment belongs only to this pilot\.$/, (item) => `Minat anda terhadap ${item} telah direkodkan. Akaun anda kekal DISAHKAN; komitmen ini hanya untuk rintis ini.`],
    [/^Track registration quality and readiness across (.+), without exposing personal details\.$/, (period) => `Jejaki kualiti dan kesediaan pendaftaran sepanjang ${translateDynamic(period)}, tanpa mendedahkan butiran peribadi.`],
    [/^Compare grouped category, product and district demand across (.+)\.$/, (period) => `Bandingkan permintaan kategori, produk dan daerah secara berkumpulan sepanjang ${translateDynamic(period)}.`],
    [/^Review which demand groups are ready for supplier engagement across (.+)\.$/, (period) => `Semak kumpulan permintaan yang sedia untuk penglibatan pembekal sepanjang ${translateDynamic(period)}.`],
    [/^Generate privacy-safe summaries for internal review and supplier conversations across (.+)\.$/, (period) => `Jana ringkasan selamat privasi untuk semakan dalaman dan perbincangan pembekal sepanjang ${translateDynamic(period)}.`],
    [/^(.+) in (last 7 days|last 30 days|all time)$/i, (change, period) => `${change} dalam ${translateDynamic(period.replace(/^./, (letter) => letter.toUpperCase()))}`],
    [/^members showing an active buying signal in (.+)\.$/, (scope) => `ahli menunjukkan isyarat pembelian aktif di ${translateDynamic(scope)}.`],
    [/^Inspect (.+)$/, (label) => `Periksa ${translateDynamic(label)}`],
    [/^(.+) segment opened — prototype view$/, (label) => `Segmen ${translateDynamic(label)} dibuka — paparan prototaip`],
    [/^(.+) downloaded$/, (label) => `${label} dimuat turun`],
    [/^(.+) design selected$/, (label) => `Reka bentuk ${translateDynamic(label)} dipilih`],
    [/^View (.+) details$/, (label) => `Lihat butiran ${translateDynamic(label)}`],
    [/^Preview (.+)$/, (label) => `Pratonton ${translateDynamic(label)}`],
    [/^Download (.+)$/, (label) => `Muat turun ${translateDynamic(label)}`],
    [/^Updated (.+)$/, (when) => `Dikemas kini ${translateDynamic(when)}`],
    [/^Added (.+)$/, (when) => `Ditambah pada ${translateDynamic(when)}`],
    [/^(\d+) products? · (\d+) brands?$/, (productCount, brandCount) => `${productCount} produk · ${brandCount} jenama`],
    [/^(\d+) of (\d+) commitments$/, (count, target) => `${count} daripada ${target} komitmen`],
    [/^([\d,.]+)% rate$/, (value) => `${value}% kadar`],
    [/^([\d,.]+)% of verified$/, (value) => `${value}% daripada yang disahkan`],
    [/^([\d,.]+)% of total$/, (value) => `${value}% daripada jumlah`],
    [/^([\d,]+) members$/, (count) => `${count} ahli`],
    [/^([\d,]+) units$/, (count) => `${count} unit`],
    [/^(\d+) districts$/, (count) => `${count} daerah`],
    [/^(\d+) × 10kg bags$/, (count) => `${count} × beg 10kg`],
    [/^Today, (.+) (am|pm)$/, (time, marker) => `Hari ini, ${time} ${marker === "am" ? "PG" : "PTG"}`],
    [/^(\d{1,2}) Oct$/, (day) => `${day} Okt`],
    [/^The signal has reached (\d+) prototype commitments across (.+)\. The next production step is supplier review with aggregate evidence only\.$/, (count, coverage) => `Isyarat telah mencapai ${count} komitmen prototaip merentasi ${translateDynamic(coverage)}. Langkah produksi seterusnya ialah semakan pembekal menggunakan bukti agregat sahaja.`],
    [/^(.+) evidence preview opened$/, (label) => `Pratonton bukti ${translateDynamic(label)} dibuka`],
    [/^Illustrative registration clusters across Sabah with the latest prototype registration plotted after (.+) was selected\.?$/, (district) => `Kelompok pendaftaran ilustrasi di seluruh Sabah dengan pendaftaran prototaip terkini diplot selepas ${district} dipilih.`],
    [/^with the latest prototype registration plotted after (.+) was selected$/, (district) => `dengan pendaftaran prototaip terkini diplot selepas ${district} dipilih`],
    [/^Illustrative registration clusters across Sabah\. No device location has been captured in this browser\.$/, () => "Kelompok pendaftaran ilustrasi di seluruh Sabah. Tiada lokasi peranti dirakam dalam pelayar ini."],
    [/^Current prototype registration captured after (.+) was selected, accuracy approximately (\d+) metres$/, (district, accuracy) => `Pendaftaran prototaip semasa dirakam selepas ${district} dipilih, ketepatan kira-kira ${accuracy} meter`],
    [/^Current prototype registration · selected district (.+) · ±(\d+) metres$/, (district, accuracy) => `Pendaftaran prototaip semasa · daerah dipilih ${district} · ±${accuracy} meter`],
    [/^(.+): ([\d,]+) illustrative registrations$/, (district, count) => `${district}: ${count} pendaftaran ilustrasi`],
    [/^Captured · ±(\d+) m$/, (accuracy) => `Dirakam · ±${accuracy} m`],
    [/^Your strongest shared signal is currently groceries in (.+)\.$/, (district) => `Isyarat bersama terkuat anda kini ialah barangan runcit di ${district}.`],
  ];

  for (const [pattern, replacer] of patterns) {
    const match = value.match(pattern);
    if (match) return replacer(...match.slice(1));
  }
  return value;
}

const ZH_COPY: Record<string, string> = {
  "Choose language": "选择语言",
  "Main navigation": "主导航",
  "How it works": "运作方式",
  "How It Works": "运作方式",
  "Privacy": "隐私",
  "Login": "登录",
  "Join now": "立即加入",
  "Open menu": "打开菜单",
  "Close menu": "关闭菜单",
  "Purchasing power, together": "汇聚购买力",
  "Your everyday choices can become a": "您的日常选择可以成为",
  "stronger signal.": "更强的需求信号。",
  "Tell us what you regularly buy. We combine anonymous demand to help open better supplier conversations—without asking you to purchase anything.": "告诉我们您经常购买什么。我们汇总匿名需求，以便与供应商进行更有利的协商，而无需您承诺购买。",
  "Add my buying signal": "添加我的购买需求",
  "Key privacy commitments": "主要隐私承诺",
  "Free to join": "免费加入",
  "No card details": "无需银行卡资料",
  "Location only with permission": "仅在获得许可后使用位置",
  "Illustration showing individual buying signals becoming collective demand": "个人购买需求汇聚成集体需求的示意图",
  "Community pulse": "社区动态",
  "buying signals": "购买需求",
  "Groceries": "日常杂货",
  "Home care": "家居护理",
  "Personal care": "个人护理",
  "Mobile & data": "移动通信与数据",
  "Transport": "交通出行",
  "Baby products": "婴儿用品",
  "Food & dining": "食品与餐饮",
  "Clothing": "服装",
  "Product catalogue": "产品目录",
  "Automatically based on the products in your wishlist.": "根据您心愿单中的产品自动生成。",
  "Cooking oil": "食用油",
  "Rice": "大米",
  "Fresh milk": "鲜奶",
  "Eggs": "鸡蛋",
  "Coffee": "咖啡",
  "Instant noodles": "方便面",
  "Laundry detergent": "洗衣液",
  "Detergent": "洗衣液",
  "Dishwashing liquid": "洗洁精",
  "Tissue": "纸巾",
  "Floor cleaner": "地板清洁剂",
  "Alcoholic Beverages": "酒精饮料",
  "Bath & Body Wash": "沐浴与身体清洁",
  "Breads & Bakery": "面包与烘焙食品",
  "Cereals & Breakfast Foods": "谷物与早餐食品",
  "Canned & Preserved Foods": "罐头与腌制食品",
  "Chips, Nuts & Seeds": "薯片、坚果与种子",
  "Chocolates & Sweets": "巧克力与糖果",
  "Home Cleaning Supplies": "家居清洁用品",
  "Coffee, Tea & Infusions": "咖啡、茶与冲泡饮品",
  "Biscuits & Confectionery": "饼干与糖果糕点",
  "Cooking Oils & Fats": "食用油与油脂",
  "Baby Diapers & Care": "婴儿尿布与护理",
  "Beverages & Refreshments": "饮料与清凉饮品",
  "Small Home Appliances": "小型家用电器",
  "Pantry Staples": "厨房常备食品",
  "Hair Care & Styling": "护发与造型",
  "Household Essentials": "家居必需品",
  "Pest & Insect Control": "害虫与昆虫防治",
  "Instant Beverage Mixes": "即冲饮料",
  "Noodles, Pasta & Quick Meals": "面条、意面与速食",
  "Laundry Care": "衣物护理",
  "Health & Remedies": "健康与常用药品",
  "Ready-to-Drink Milk": "即饮牛奶",
  "Powdered Milk & Formula": "奶粉与配方奶",
  "Oral Care": "口腔护理",
  "Paper Goods & Tissue": "纸制品与纸巾",
  "Fragrances & Deodorants": "香水与除臭用品",
  "Pet Food & Supplies": "宠物食品与用品",
  "Feminine Hygiene": "女性卫生用品",
  "Sauces & Condiments": "酱料与调味品",
  "Seasonings & Flavour Enhancers": "调味料与增味品",
  "Skin Care & Beauty": "护肤与美容",
  "Savoury Snacks": "咸味零食",
  "Breakfast Spreads": "早餐涂抹酱",
  "Shampoo": "洗发水",
  "Body wash": "沐浴露",
  "Toothpaste": "牙膏",
  "Skincare": "护肤品",
  "Diapers": "尿布",
  "Baby formula": "婴儿配方奶粉",
  "Baby wipes": "婴儿湿巾",
  "Baby toiletries": "婴儿洗护用品",
  "Mobile data": "移动数据",
  "Home internet": "家庭宽带",
  "Prepaid top-up": "预付费充值",
  "Fuel": "燃油",
  "E-hailing": "网约车",
  "Public transport pass": "公共交通月票",
  "Family meals": "家庭餐饮",
  "Lunch deals": "午餐优惠",
  "Coffee & drinks": "咖啡与饮品",
  "School uniforms": "校服",
  "Workwear": "工作服",
  "Everyday basics": "日常基础服饰",
  "Latest community demand": "最新社区需求",
  "Regular products summary": "常购产品摘要",
  "product selections": "产品选择次数",
  "unique products": "不同产品",
  "No regular product selections yet.": "暂时没有常购产品选择。",
  "Brands summary": "品牌摘要",
  "brand selections": "品牌选择次数",
  "unique brands": "不同品牌",
  "No brand selections yet.": "暂时没有品牌选择。",
  "High-demand products": "高需求产品",
  "active members": "活跃会员",
  "No products are currently selected by two or more active members.": "目前没有产品被两名或以上活跃会员选择。",
  "New brands added": "新增品牌",
  "approved additions": "已批准新增",
  "new brands": "新品牌",
  "No suggested brands have been approved yet.": "暂时没有获批准的建议品牌。",
  "Close summary": "关闭摘要",
  "Rank": "排名",
  "Based only on current selections from active member accounts. Archived and deleted users are excluded.": "仅根据活跃会员账户的当前选择统计，已归档和已删除的用户不计入。",
  "Suggested by members and approved by Kitanego administrators.": "由会员建议并经 Kitanego 管理员批准。",
  "Strongest signal": "最强需求",
  "How Kitanego works": "Kitanego 的运作方式",
  "Simple registration": "简易注册",
  "Submit product needs": "提交产品需求",
  "No payment required": "无需付款",
  "Self-managed user details": "自行管理用户资料",
  "One small signal. A clearer picture.": "一个小信号，形成更清晰的需求图景。",
  "A simple journey from routine spending to credible demand.": "将日常消费转化为可靠需求的简单流程。",
  "Tell us what matters": "告诉我们您的需要",
  "Choose the things you buy regularly, using simple ranges—not exact financial information.": "选择您经常购买的商品，只需提供大致范围，无需准确的财务资料。",
  "We combine the signal": "我们汇总需求",
  "Your choices join anonymous totals by product and area. Suppliers never see a member list.": "您的选择会按产品和地区匿名汇总，供应商不会看到会员名单。",
  "Opportunities can follow": "需求成熟后会有新机会",
  "If credible demand exists, the community can explore an offer. You decide whether to take part.": "当需求足够可靠时，社区可探索相关优惠，是否参与由您决定。",
  "A dashboard worth returning to": "值得持续关注的仪表板",
  "See your signal—and the community forming around it.": "查看您的需求，以及围绕它形成的社区力量。",
  "Members can update interests, understand what suppliers see, and verify only when a relevant pilot opportunity appears.": "会员可更新兴趣、了解供应商看到的内容，并只在相关试点机会出现时进行验证。",
  "Open member dashboard": "打开会员主页",
  "Good morning": "早上好",
  "Good afternoon": "下午好",
  "Good evening": "晚上好",
  "Good night": "晚安",
  "Your signal is live.": "您的需求信号已生效。",
  "Demand pulse": "需求动态",
  "REGISTERED": "已注册",
  "Profile complete": "资料已完成",
  "Tailored to your daily needs": "贴合您的日常需要",
  "The Power of Collective Buying with Kitanego": "与 Kitanego 汇聚集体购买力",
  "Turn your regular purchases into collective buying power. Join our community to signal high demand and unlock exclusive value on the products you already need.": "将日常购买转化为集体购买力。加入社区，汇聚需求，为您真正需要的产品争取更好价值。",
  "Deals Tailored to You": "为您量身打造的优惠",
  "Personalized discounts for your household's favorite products.": "为家庭常用产品提供更合适的优惠。",
  "Wholesale Prices Together": "共同争取批发价格",
  "Our big community pools its orders to cut retail costs.": "社区汇总需求，争取降低零售成本。",
  "Zero obligation": "无需承担购买义务",
  "Submit demands or share opinions freely; you only buy what you want.": "您可以自由提交需求或分享意见，只购买自己想要的商品。",
  "Privacy by design": "隐私优先设计",
  "Hands using Kitanego to choose the groceries category and select rice": "使用 Kitanego 选择杂货类别和大米产品",
  "Basic details info": "仅需基本资料",
  "Verify you're human to keep our insights accurate.": "确认您是真实用户，以保持数据准确。",
  "Supplier supporting documentation": "供应商参考资料",
  "Your feedback as evidence of demand via our primary solution.": "您的反馈将作为需求依据。",
  "Tell us your monthly needs": "告诉我们您的每月需求",
  "We combine everyone's demand to negotiate better prices with suppliers.": "我们汇总大家的需求，与供应商协商更好的价格。",
  "Products on demand": "热门需求产品",
  "Shared needs. Fairer prices. For everyone.": "共同需求，更合理的价格，人人受益。",
  "Making everyday essentials affordable for everyone, together.": "一起让日常必需品更实惠。",
  "Let's do it!": "现在开始！",
  "Demand better prices, together.": "汇聚需求，共同争取更好价格。",
  "Admin login": "管理员登录",
  "Company": "公司",
  "About us": "关于我们",
  "Who we are": "我们是谁",
  "Support": "支持",
  "Contact us": "联系我们",
  "FAQ": "常见问题",
  "Legal": "法律信息",
  "Privacy policy": "隐私政策",
  "Terms of use": "使用条款",
  "Cookie notice": "浏览器存储通知",
  "Access": "访问",
  "© 2026 Kitanego. All rights reserved.": "© 2026 Kitanego。版权所有。",
  "This information page is being prepared.": "此信息页面正在准备中。",
  "Home": "首页",
  "Wishlists": "心愿单",
  "Demand": "需求",
  "Opportunities": "机会",
  "Profile": "个人资料",
  "Member navigation": "会员导航",
  "Notifications": "通知",
  "Your monthly Demand": "您的每月需求",
  "Latest updates": "最新动态",
  "high demand products": "高需求产品",
  "high demand product": "高需求产品",
  "brands selected": "已选品牌",
  "new brands added": "新增品牌",
  "new brand added": "新增品牌",
  "Last login:": "上次登录：",
  "Welcome to Kitanego!": "欢迎来到 Kitanego！",
  "We are absolutely thrilled to have you with us. 🙌 Thank you for joining this movement right from the start. By registering, you aren't just joining a platform—you are helping launch something massive. Together, we are building a powerful collective-buying network that will fundamentally change lives and bring much-needed relief to communities that need it most. Your presence makes our collective voice stronger. Get ready, because we are about to make a huge impact together!": "我们非常高兴有您的加入。🙌 感谢您从一开始就参与这项行动。注册 Kitanego 不只是加入一个平台，更是在帮助启动一个重要的集体购买网络。我们正在共同汇聚消费者的需求，为最需要帮助的社区争取更实惠的日常用品。您的参与让我们的集体声音更有力量。让我们一起创造真正的改变！",
  "We are absolutely thrilled to have you with us. 🙌 Thank you for joining this effort right from the start. By registering, you aren't just joining a platform—you are helping launch something massive. Together, we are building a powerful collective-buying network that will fundamentally change lives and bring much-needed relief to communities that need it most. Your presence makes our collective voice stronger. Get ready, because we are about to make a huge impact together!": "我们非常高兴有您的加入。🙌\n\n感谢您从一开始就参与这项计划。注册后，您不只是加入一个平台，更是在帮助启动一项意义重大的事业。\n\n我们正在共同建立一个强大的集体购买网络，为生活带来根本性的改变，并为最需要帮助的社区带来急需的支持。\n\n您的参与让我们的集体声音更有力量。准备好与我们一起创造巨大的影响吧！",
  "Loading latest news…": "正在加载最新消息…",
  "Latest news is temporarily unavailable": "暂时无法查看最新消息",
  "No latest news yet": "暂时没有最新消息",
  "Please check again shortly.": "请稍后再查看。",
  "Updates posted by Kitanego will appear here.": "Kitanego 发布的更新将显示在这里。",
  "No monthly wishlist yet.": "暂时没有每月心愿单。",
  "Loading your wishlists…": "正在加载您的心愿单…",
  "Your monthly wishlists are temporarily unavailable.": "暂时无法读取您的每月心愿单。",
  "My Wishlists": "我的心愿单",
  "Regular products and brands.": "常购产品与品牌。",
  "products": "产品",
  "brands": "品牌",
  "categories": "类别",
  "Your favourite brands": "您喜爱的品牌",
  "Your brands": "您的品牌",
  "My favourite brands": "我喜爱的品牌",
  "My brand lists": "我的品牌列表",
  "Search or add a brand": "搜索或添加品牌",
  "Search catalogue brands": "搜索品牌目录",
  "Search or add a product": "搜索或添加产品",
  "How often do you buy": "您的购买频率",
  "How often do I buy": "我的购买频率",
  "Welcome to Kitanego — your choices help build stronger collective demand.": "欢迎来到 Kitanego——您的选择有助于汇聚更强大的集体需求。",
  "Your regular products": "您的常购产品",
  "You regular product": "您的常购产品",
  "Milk": "鲜奶",
  "Selected brands": "已选品牌",
  "Selected brand": "已选品牌",
  "Product category": "产品类别",
  "Your product category": "您的产品类别",
  "Automatically based on this month’s selected products.": "根据本月所选产品自动生成。",
  "Lists of Brands": "品牌列表",
  "Suggested matches": "建议匹配",
  "Can’t find it? Suggest a new brand for review": "找不到？建议新品牌供审核",
  "Under review": "审核中",
  "Brand submitted and added to your list. It is under review.": "品牌已提交并添加到您的列表，目前正在审核中。",
  "Brand added to your list. It will be submitted for review when registration is completed.": "品牌已添加到您的列表，完成注册后将提交审核。",
  "Select a listed brand or suggest a new brand for review.": "选择目录中的品牌，或提交新品牌供审核。",
  "Settings": "设置",
  "Log out": "退出登录",
  "Dashboard": "主页",
  "Profile settings": "个人资料设置",
  "Language": "语言",
  "English": "英语",
  "Chinese": "中文",
  "Bahasa Malaysia": "马来西亚国语",
  "Bahasa Sabah": "沙巴马来语",
  "Next": "下一步",
  "Monthly Wishlist": "每月心愿单",
  "When do you plan to buy?": "您计划何时购买？",
  "Choose a wishlist month": "选择心愿单月份",
  "Choose a month": "选择月份",
  "Select one month to continue": "选择一个月份以继续",
  "Pick your products": "选择您的产品",
  "Choose your shopping list for this month.": "选择本月的购物清单。",
  "Choose your brands.": "选择您的品牌。",
  "Select brands from the list, search, or add a new brand. This step is optional.": "从列表中选择品牌、搜索或添加新品牌。此步骤为可选项。",
  "Budget spending plan": "预算支出计划",
  "How do you plan on buying the items on your wishlist?": "您计划如何购买心愿单中的商品？",
  "How often do you buy these products?": "您多久购买一次这些产品？",
  "Expected monthly spend": "预计每月支出",
  "Hoping to find a more budget-friendly option": "希望找到更实惠的选择",
  "Review": "检查",
  "Your product categories are created automatically from your selected products.": "系统会根据您选择的产品自动创建产品类别。",
  "Expected spend": "预计支出",
  "Submitting…": "正在提交…",
  "your selected month": "您选择的月份",
  "wishlist saved": "心愿单已保存",
  "Your monthly wishlist could not be saved. Please try again.": "无法保存您的每月心愿单。请重试。",
  "No matching products": "没有匹配的产品",
  "Try another product name or clear your search.": "请尝试其他产品名称或清除搜索。",
  "Clear search": "清除搜索",
  "Your favourite brand": "您喜爱的品牌",
  "View retail item": "查看零售产品",
  "Brand image not available": "品牌图片不可用",
  "Finding brand names…": "正在查找品牌名称…",
  "Sending suggestion…": "正在发送建议…",
  "Suggest": "建议",
  "Web App Admin will review its name and image": "网站应用管理员将审核其名称和图片",
  "This brand is already selected.": "此品牌已被选择。",
  "No listed catalogue brands match your search.": "没有符合搜索条件的目录品牌。",
  "All available brands are selected.": "所有可用品牌均已选择。",
  "Step 2 of 5": "第 2 步，共 5 步",
  "Choose your district.": "选择您的地区。",
  "District in Sabah": "沙巴地区",
  "Select your district": "选择您的地区",
  "Step 3 of 5": "第 3 步，共 5 步",
  "Choose the products you buy regularly.": "选择您经常购买的产品。",
  "Step 4 of 5": "第 4 步，共 5 步",
  "Select a brand from the available list. You can suggest a new brand after registration.": "从可用列表中选择品牌。注册后您可以建议新品牌。",
  "Step 5 of 5": "第 5 步，共 5 步",
  "How does this fit your routine?": "这如何融入您的日常生活？",
  "An estimate is enough. We use ranges, not exact spending.": "估算即可。我们使用范围，而不是确切支出。",
  "How often do you usually buy these?": "您通常多久购买一次这些产品？",
  "About how much at a time?": "每次大约花费多少？",
  "If a better price became available…": "如果有更优惠的价格…",
  "Saving…": "正在保存…",
  "Back": "返回",
  "Save": "保存",
  "Update": "更新",
  "My product category": "我的产品类别",
  "Listed based on my wishlists product": "根据我的心愿单产品列出",
  "Interest sections": "心愿单分区",
  "Clear product search": "清除产品搜索",
  "Save and confirm product choices": "保存并确认产品选择",
  "Open product editor": "打开产品编辑器",
  "Add existing product": "添加现有产品",
  "Suggest a new product": "建议新产品",
  "Clear brand search": "清除品牌搜索",
  "Save and confirm brand choices": "保存并确认品牌选择",
  "Choose a listed brand": "选择目录中的品牌",
  "Open brand editor": "打开品牌编辑器",
  "Add listed brand": "添加目录品牌",
  "Send to Web App Admin for review": "提交给网站管理员审核",
  "Enter at least two letters to search or suggest a brand.": "请输入至少两个字母以搜索或建议品牌。",
  "Select a product to automatically add its category.": "选择产品后将自动添加其类别。",
  "Choose your regular products": "选择您的常购产品",
  "Choose your regular brands": "选择您的常购品牌",
  "Select": "选择",
  "Unselect": "取消选择",
  "Add": "添加",
  "product": "产品",
  "image": "图片",
  "Enlarge": "放大",
  "No products match your search.": "没有符合搜索条件的产品。",
  "Select at least one category to see its products.": "请至少选择一个类别以查看产品。",
  "No selected products match your search.": "已选产品中没有符合搜索条件的项目。",
  "Individual retail item": "单件零售商品",
  "Brand image not available yet": "品牌图片暂不可用",
  "No linked products yet": "暂时没有关联产品",
  "No brands match your search.": "没有符合搜索条件的品牌。",
  "All available brands are already selected.": "所有可用品牌均已选择。",
  "No selected brands match your search.": "已选品牌中没有符合搜索条件的项目。",
  "Add a brand with the search or plus button above.": "请使用上方搜索或加号按钮添加品牌。",
  "PRODUCT CATEGORY": "产品类别",
  "How often do I buy this?": "我多久购买一次？",
  "Remove product": "移除产品",
  "Close product details": "关闭产品详情",
  "BRAND DETAILS": "品牌详情",
  "How often do I buy this brand?": "我多久购买一次这个品牌？",
  "Remove brand": "移除品牌",
  "Close brand details": "关闭品牌详情",
  "Close enlarged image": "关闭放大图片",
  "Your monthly demand.": "您的每月需求。",
  "Choose a monthly demand": "选择每月需求",
  "Remove": "移除",
  "Search products": "搜索产品",
  "Choose your products": "选择产品",
  "Choose your brands": "选择品牌",
  "Frequency": "购买频率",
  "Buying frequency": "购买频率",
  "Products": "产品",
  "Categories": "类别",
  "Brands": "品牌",
  "Approximate spend": "预计花费",
  "Submit": "提交",
  "Daily": "每日",
  "Weekly": "每周",
  "Every two weeks": "每两周",
  "Monthly": "每月",
  "Every few months": "每几个月",
  "Occasionally": "偶尔",
  "Under RM50": "RM50以下",
  "RM50–RM100": "RM50–RM100",
  "RM101–RM250": "RM101–RM250",
  "RM251–RM500": "RM251–RM500",
  "Above RM500": "RM500以上",
  "Definitely interested": "非常感兴趣",
  "Probably interested": "可能感兴趣",
  "Maybe if price is better": "如果价格更优惠，可能会感兴趣",
  "Not interested": "不感兴趣",
};

export function toChinese(value: string): string {
  const direct = findTranslatedCopy(ZH_COPY, value);
  if (direct) return direct;
  const patterns: Array<[RegExp, (...parts: string[]) => string]> = [
    [/^Good morning, (.+)\.$/, (name) => `早上好，${name}。`],
    [/^Good afternoon, (.+)\.$/, (name) => `下午好，${name}。`],
    [/^Good evening, (.+)\.$/, (name) => `晚上好，${name}。`],
    [/^Good night, (.+)\.$/, (name) => `晚安，${name}。`],
    [/^Last login: (.+)$/, (when) => `上次登录：${when}`],
    [/^(\d+) products?$/, (count) => `${count} 个产品`],
    [/^(\d+) brands?$/, (count) => `${count} 个品牌`],
    [/^Updated (.+)$/, (when) => `更新于 ${when}`],
    [/^Added (.+)$/, (when) => `添加于 ${when}`],
    [/^(\d+) products? · (\d+) brands?$/, (productCount, brandCount) => `${productCount} 个产品 · ${brandCount} 个品牌`],
  ];
  for (const [pattern, replacer] of patterns) {
    const match = value.match(pattern);
    if (match) return replacer(...match.slice(1));
  }
  return value;
}

export function toSabahMalay(value: string): string {
  const direct = SABAH_COPY[value];
  if (direct) return direct;

  const standardMalay = translateDynamic(value);
  const standardDirect = SABAH_COPY[standardMalay];
  if (standardDirect) return standardDirect;

  return standardMalay
    .replace(/\bTiada\b/g, "Nda ada")
    .replace(/\btiada\b/g, "nda ada")
    .replace(/\bTidak\b/g, "Nda")
    .replace(/\btidak\b/g, "nda")
    .replace(/\bAnda\b/g, "Kamu")
    .replace(/\banda\b/g, "kamu")
    .replace(/\bSahaja\b/g, "Saja")
    .replace(/\bsahaja\b/g, "saja")
    .replace(/\bMahu\b/g, "Mau")
    .replace(/\bmahu\b/g, "mau")
    .replace(/\bTelah\b/g, "Sudah")
    .replace(/\btelah\b/g, "sudah")
    .replace(/\bSedang\b/g, "Tengah")
    .replace(/\bsedang\b/g, "tengah")
    .replace(/\bBeritahu\b/g, "Bagitau")
    .replace(/\bberitahu\b/g, "bagitau")
    .replace(/\bKembali\b/g, "Balik")
    .replace(/\bkembali\b/g, "balik")
    .replace(/\bLihat\b/g, "Tengok")
    .replace(/\blihat\b/g, "tengok")
    .replace(/\bPergi\b/g, "Pigi")
    .replace(/\bpergi\b/g, "pigi")
    .replace(/\bOrang\b/g, "Urang")
    .replace(/\borang\b/g, "urang")
    .replace(/\bMemberi\b/g, "Kasi")
    .replace(/\bmemberi\b/g, "kasi")
    .replace(/\bSaya\b/g, "Sia")
    .replace(/\bsaya\b/g, "sia");
}

function translateForLanguage(value: string, language: InterfaceLanguage): string {
  if (language === "ms") return translateDynamic(value);
  if (language === "sabah") return toSabahMalay(value);
  if (language === "zh") return toChinese(value);
  return value;
}

export function translateInterfaceText(value: string, language: InterfaceLanguage): string {
  return translateForLanguage(value, language);
}

function translatePreservingWhitespace(value: string, language: InterfaceLanguage): string {
  const leading = value.match(/^\s*/)?.[0] ?? "";
  const trailing = value.match(/\s*$/)?.[0] ?? "";
  const core = value.trim();
  if (!core) return value;
  return `${leading}${translateForLanguage(core, language)}${trailing}`;
}

function localiseTextNode(node: Text, language: InterfaceLanguage) {
  const current = node.data;
  const known = textOriginals.get(node);
  const knownTranslations = known ? [translatePreservingWhitespace(known, "ms"), translatePreservingWhitespace(known, "sabah"), translatePreservingWhitespace(known, "zh")] : [];
  if (!known || (current !== known && !knownTranslations.includes(current))) textOriginals.set(node, current);
  const source = textOriginals.get(node) ?? current;
  const next = translatePreservingWhitespace(source, language);
  if (node.data !== next) node.data = next;
}

function localiseElementAttributes(element: Element, language: InterfaceLanguage) {
  let originals = attributeOriginals.get(element);
  if (!originals) {
    originals = new Map();
    attributeOriginals.set(element, originals);
  }
  for (const attribute of translatedAttributes) {
    const current = element.getAttribute(attribute);
    if (current === null) continue;
    const known = originals.get(attribute);
    const knownTranslations = known ? [translateForLanguage(known, "ms"), translateForLanguage(known, "sabah"), translateForLanguage(known, "zh")] : [];
    if (!known || (current !== known && !knownTranslations.includes(current))) originals.set(attribute, current);
    const source = originals.get(attribute) ?? current;
    const next = translateForLanguage(source, language);
    if (current !== next) element.setAttribute(attribute, next);
  }
}

function localiseSubtree(root: Node, language: InterfaceLanguage) {
  if (root.nodeType === Node.TEXT_NODE) {
    localiseTextNode(root as Text, language);
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE) return;
  const element = root as Element;
  localiseElementAttributes(element, language);
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
  let current = walker.nextNode();
  while (current) {
    if (current.nodeType === Node.TEXT_NODE) localiseTextNode(current as Text, language);
    else localiseElementAttributes(current as Element, language);
    current = walker.nextNode();
  }
}

export function mountInterfaceLocalisation(root: HTMLElement, language: InterfaceLanguage) {
  localiseSubtree(root, language);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === "characterData") localiseTextNode(record.target as Text, language);
      if (record.type === "attributes") localiseElementAttributes(record.target as Element, language);
      for (const node of record.addedNodes) localiseSubtree(node, language);
    }
  });
  observer.observe(root, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: [...translatedAttributes],
  });
  return () => observer.disconnect();
}
